import { Component, computed, inject, input, InputSignal, ChangeDetectionStrategy } from '@angular/core';
import { CardMode } from '@components/card/card.component';
import { Study } from '@models/study';
import { GroupService } from '@services/group/group.service';
import { TravelViewModelService } from '@services/travel-view-model/travel-view-model.service';
import { OtherRequestDetailsFormGroup } from '../../form-groups/detail-form-groups/travel/other-request.formgroup';
import { NeedsTravelFormGroup, NoPreferenceTravelFormGroup } from '../../form-groups/travel-request-card.formgroup';
import { NeedsTravelRadioGroupComponent } from '../../needs-travel-radio-group/needs-travel-radio-group.component';
import { OtherRequestDetailsComponent } from './other-request-details/other-request-details.component';

@Component({
    selector: 'medpace-other-travel-request-tab',
    imports: [NeedsTravelRadioGroupComponent, OtherRequestDetailsComponent],
    templateUrl: './other-travel-request-tab.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './other-travel-request-tab.component.scss',
})
export class OtherTravelRequestTabComponent {
    private readonly travelViewModelService = inject(TravelViewModelService);
    private readonly groupService = inject(GroupService);

    public readonly mode: InputSignal<CardMode> = input.required();
    public readonly study: InputSignal<Study> = input.required();
    public readonly formGroup: InputSignal<
        NeedsTravelFormGroup<NoPreferenceTravelFormGroup<OtherRequestDetailsFormGroup>>
    > = input.required();

    public readonly isUpdate = computed(() => !!this.travelViewModelService.travelCardViewModel()?.isUpdate);
}
